import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';

import IconTab from '../../../../id8/components/icon-tab/IconTab';
import { ACTIV8_MESSAGE_GENERATE_TABS } from '../../../../constants';

const useGenerateTabs = () => {
  const { t } = useTranslation('activ8');

  return useMemo(() => {
    return [
      {
        label: (
          <IconTab label={t('generated')} icon={NotesOutlinedIcon} index={ACTIV8_MESSAGE_GENERATE_TABS.GENERATED} />
        ),
        disabled: false,
      },
      {
        label: (
          <IconTab label={t('saved')} icon={BookmarkBorderOutlinedIcon} index={ACTIV8_MESSAGE_GENERATE_TABS.SAVED} />
        ),
        disabled: false,
      },
    ];
  }, [t]);
};

export default useGenerateTabs;
